module.exports = __webpack_public_path__ + "static/media/info.5b3a5b1e.svg";